import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

/** A conversation the message can go to: a row of the chat list as the store holds it. */
export interface ForwardTarget {
  id: string;
  title: string;
  titleAvatarInfo?: any;
  isGroupConversation?: boolean;
  sourceType?: string;
}

export interface ForwardMessageDialogData {
  /** The loaded chat list (the list's own `queryConversations`), in its order. */
  conversations: ForwardTarget[];
  /** The forwarded message's text, as the thread shows it. */
  preview: string;
}

/**
 * THE FORWARD PICKER (ITP-E-194-06, B-11). The conversations the list has loaded, searchable by title; the member ticks
 * one or more and the dialog closes with their ids. The thread sends them through the message actions port.
 */
@Component({
  standalone: false,
  selector: 'messenger-forward-message-dialog',
  templateUrl: './forward-message-dialog.component.html',
  styleUrls: ['./forward-message-dialog.component.scss']
})
export class ForwardMessageDialogComponent {
  searchText = '';
  readonly selected = new Set<string>();

  constructor(private dialogRef: MatDialogRef<ForwardMessageDialogComponent, string[]>,
              @Inject(MAT_DIALOG_DATA) public data: ForwardMessageDialogData) {
  }

  get visibleConversations(): ForwardTarget[] {
    const query = this.searchText.trim().toLowerCase();
    const all = this.data.conversations || [];
    return query ? all.filter(conversation => (conversation.title || '').toLowerCase().includes(query)) : all;
  }

  toggle(conversation: ForwardTarget): void {
    if (this.selected.has(conversation.id)) {
      this.selected.delete(conversation.id);
    } else {
      this.selected.add(conversation.id);
    }
  }

  trackById(index: number, conversation: ForwardTarget): string {
    return conversation.id;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onForward(): void {
    if (this.selected.size) {
      this.dialogRef.close([...this.selected]);
    }
  }
}
